<template>
  <div class="form">
    <app-logo class="form__logo" />
    <app-form-progress class="form__progress" />
    <app-form-title
      v-if="currentStep !== 6"
      class="form__title"
    />
    <app-form-steps
      class="form__step"
      :class="`form__step--${currentStep}`"
    />
    <app-form-controls class="form__controls" />
    <div 
      class="form__mandatory"
      :class="{ 'form__mandatory--hide': currentStep > 4 }"
    >
      <span
        class="form__mandatory__asterisk"
        v-html="'*&nbsp;'"
      />
      <app-i18n
        class="form__mandatory__label"
        code="teamRegistrationSite.form.mandatoryFields"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppLogo from '@/components/Logo.vue'
import AppFormProgress from '@/components/FormProgress.vue'
import AppFormTitle from '@/components/FormTitle.vue'
import AppFormSteps from '@/components/FormSteps.vue'
import AppFormControls from '@/components/FormControls.vue'

export default {
  name: 'appForm',
  computed: {
    ...mapState('form', ['currentStep']),
  },
  components: {
    AppLogo,
    AppFormProgress,
    AppFormTitle,
    AppFormSteps,
    AppFormControls,
  },
  mounted() {
    window.addEventListener('touchstart', ev => {  // Fixes select fields behaviour in mobile, where scrolling over them selected the items inside
      if (ev.target.classList.contains('el-select-dropdown__item')) event.stopPropagation();
    }, true);   
  }
}
</script>

<style lang="scss" scoped>
.form {
  &__progress {
    margin-bottom: 24px;

    @include tablet {
      margin: 24px 0;
    }

    @include desktop {
      margin: 40px 0;
    }
  }

  &__logo {
    max-width: 128px;
    margin: 16px auto;

    @include tablet {
      max-width: 200px;
    }

    @include desktop {
      max-width: 240px;
      margin: 32px auto 24px;
    }
  }

  &__title {
    margin: 0 auto 16px;
  }

  &__step {
    padding: 16px 8px 8px;
    background-color: #f8f8f8;

    @include tablet {
      padding: 24px 16px 16px;
    }

    @include desktop {
      padding: 32px 24px 16px;
    }

    &--3 {
      padding: 0;
      background-color: #fff;
    }

    &--4 {
      padding: 0;
      text-align: left;
      background-color: #fff;
    }

    &--5 {
      padding: 0 0 8px;
      text-align: left;
      background-color: #fff;
    }

    &--6 {
      padding: 0;
      background-color: #fff;
    }
  }

  &__controls {
    margin: 24px 0 16px;

    @include desktop {
      margin: 32px 0 24px;
    }
  }

  &__mandatory {
    display: inline-flex;
    align-items: center;

    &--hide {
      display: none;
    }

    &__label,
    &__asterisk {
      font-size: 10px;
    }
  }
}
</style>

<style lang="scss">
.form {
  &__step {
    .el-form {
      padding: 0;
    }
  }
}
</style>
